export default __webpack_public_path__ + "static/media/hero-2.6c83cd32.jpg";